/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2020-09-04 15:11:43
 * @LastEditors: chenzhi
 * @LastEditTime: 2023-08-16 14:10:51
 */
import { service } from '@/utils/http'
import { getFormData } from '@/utils/index'

/**
 * 分页查询视频列表
 * @param data
 * @returns
 */
export function pageVideoList(data: any): Res<any> {
  return service.post('/h5/video/pageVideoList', data)
}

/**
 * 分页查询铃声列表
 * @param data
 * @returns
 */
export function pageRingList(data: any): Res<any> {
  return service.post('/h5/ring/pageRingList', data)
}

/**
 * 分页查询壁纸列表
 * @param data
 * @returns
 */
export function pageWallpaperList(data: any): Res<any> {
  return service.post('/h5/wallpaper/pageWallpaperList', data)
}

/**
 *  根据id集合获取铃声详情集合
 * @param data
 * @returns
 */
export function getRingDetails(params: any): Res<any> {
  return service.get('/h5/ring/getRingDetails', { params })
}

/**
 * 根据id集合获取视频详情集合
 * @param data
 * @returns
 */
export function getVideoDetails(params: any): Res<any> {
  return service.get('/h5/video/getVideoDetails', { params })
}

/**
 * 根据id集合获取壁纸详情集合
 * @param params
 * @returns
 */
export function getWallpaperDetails(params: any): Res<any> {
  return service.get('/h5/wallpaper/getWallpaperDetails', { params })
}

/**
 * 获取分类列表
 * @param params
 * @returns
 */
export function listCategories(params: { type: number }): Res<any> {
  return service.get('/h5/category/listCategories', { params })
}

/**
 * 获取歌单详情
 * @param params
 * @returns
 */
export function getPlayListDetails(params: { id: any }): Res<any> {
  return service.get('/h5/playList/getPlayListDetails', { params })
}

/**
 * 分页查询歌单下铃声列表
 * @param params
 * @returns
 */
export function pageRingsByPlaylistId(data: {
  id: any
  pageNum: number
  pageSize: number
}): Res<any> {
  return service.post('/h5/playList/pageRingsByPlaylistId', data)
}

/**
 * 获取指定群信息
 * @param params
 * @returns
 */
export function getGroupInfo(params: {
  groupId: any
  inviterUserId: any
  groupName: any
  inviterName: any
}): Res<any> {
  return service.get('/h5/im/getGroupInfo', { params })
}

/**
 * 邀请方式加入群聊
 * @param data
 * @returns
 */
export function addGroupInvitation(data: {
  groupId: any
  inviterUserId: any
  invitedName: string
  invitedMobile: string
  language: any
}): Res<any> {
  return service.post('/h5/im/addGroupMemberByInvitation', data)
}

/**
 * 检查用户是否注册Allo
 * @param params
 * @returns
 */
export function checkRegister(params: { mobile: string }): Res<any> {
  return service.get('/h5/user/checkRegister', { params })
}

/**
 * 根据用户Id获取用户信息
 * @param params
 * @returns
 */
export function getUserInfoByUserId(params: { userId: any }): Res<any> {
  return service.get('/h5/user/getUserInfoByUserId', { params })
}

/**
 * 认证信息提交
 * @param data
 * @returns
 */
export function submitAuthentication(data: {
  name: string
  pictureList: any
  type: any
}): Res<any> {
  return service.post('/h5/user/submitAuthentication', data)
}

/**
 * 用户实名认证
 * @param data
 * @returns
 */
export function validateIdCard(data: {
  name: string
  idCard: string
  cardImage: string
}): Res<any> {
  return service.post('/h5/user/validateIdCard', data)
}

/**
 * 获取用户当前提交的认证信息
 * @param params
 * @returns
 */
export function getCurrentAuthentication(params: { type: number }): Res<any> {
  return service.get('/h5/user/getCurrentAuthentication', { params })
}

/**
 *  获取腾讯云临时Cos授权信息
 * @param params
 * @returns
 */
export function getOssTmpAuthInfo() {
  return service.get('/h5/config/getOssTmpAuthInfo')
}

/**
 *  获取个人信息收集清单
 * @param params
 * @returns
 */
export function getLoginUserInfo() {
  return service.get('/h5/user/getLoginUserInfo')
}

/**
 * 获取用户提交的认证类型以及审核状态
 * @param params
 * @returns
 */
export function getUserAuthenticationType(): Res<any> {
  return service.get('/h5/user/getUserAuthenticationType')
}

/**
 * 意见反馈提交
 * @param data
 * @returns
 */
export function submitFeedback(data: {
  mobile: string
  text: string
  equipmentNumber: string
  androidVersion: string
  respondent: string
  imgs: any
  version: any
}): Res<any> {
  return service.post('/h5/feedback/submitFeedback', data, {
    headers: {
      version: data.version
    }
  })
}

/**
 *获取动态详情
 * @returns
 */
export function getUpdates(params: {
  updatesId: any
  userId: number
}): Res<any> {
  return service.get('/h5/updates/getUpdates', { params })
}

/**
 * 获取频道消息详情
 * @param params
 * @returns
 */
export function getChannelMsgDetail(params: { channelMsgId: any }): Res<any> {
  return service.get('/h5/channel/getChannelMsgDetail', { params })
}

/**
 * 频道消息点赞/取消点赞
 * @param data
 * @returns
 */
export function likeChannelMsg(data: {
  channelMsgId: any
  like: number
}): Res<any> {
  return service.post('/h5/channel/likeChannelMsg', data)
}

/**
 * 评论新增/回复
 * @param data
 * @returns
 */
export function insertComment(data: {
  channelMsgId: number
  content: string
}): Res<any> {
  return service.post('/h5/channel/insertComment', data)
}

/**
 * 评论列表
 * @param params
 * @returns
 */
export function pageComment(params: {
  channelMsgId: any
  pageNum: number
  pageSize: number
}): Res<any> {
  return service.get('/h5/channel/pageComment', { params })
}

/**
 * 评论点赞/取消点赞
 * @param data
 * @returns
 */
export function likeComment(data: { id: number; type: number }): Res<any> {
  return service.post('/h5/channel/likeComment', data)
}

/**
 * 评论删除
 * @param data
 * @returns
 */
export function deleteComment(data: { id: number }): Res<any> {
  return service.post('/h5/channel/deleteComment', data)
}

/**
 * 获取预览链接信息
 * @param params
 * @returns
 */
export function getPreviewChannelMsg(params: { msgId: any }): Res<any> {
  return service.get('/h5/channel/getPreviewChannelMsg', { params })
}

/**
 * 评论投诉
 * @param data
 * @returns
 */
export function commentComplaint(data: { id: number; type: any }): Res<any> {
  return service.post('/h5/channel/commentComplaint', data)
}

/**
 * 动态评论分页获取接口
 * @param params
 * @returns
 */
export function getpageComment(params: {
  updatesId: any
  pageNum: number
  pageSize: number
}): Res<any> {
  return service.get('/h5/updates/pageComment', { params })
}

/**
 * 金豆-app提现配置列表
 * @returns
 */
export function apiGetIosVerify(): Res<any> {
  return service.get('/chatCharge/getConfig')
}

/**
 * 金豆-app提现配置列表
 * @returns
 */
export function getAppWithdrawConfigList(): Res<any> {
  return service.get('/h5/goldenBeanWithdrawConfig/getAppWithdrawConfigList')
}

/**
 * 检查用户是否绑定微信
 * @returns
 */
export function checkUserBindWx(): Res<any> {
  return service.get('/h5/user/checkUserBindWx')
}

/**
 * 申请提现接口
 * @param data
 * @returns
 */
export function applyDraw(data: {
  exchangeId: number
  payType: number
}): Res<any> {
  return service.post('/h5/gold/bean/apply/with/draw', data)
}

/**
 * 金豆获取清单
 * @returns
 */
export function getObtainDetailList(params: {
  pageNum: number
  pageSize: number
}): Res<any> {
  return service.get('/h5/gold/bean/getObtainDetailList', {
    params
  })
}

/**
 * 金豆兑换申请记录列表
 * @returns
 */
export function getExchangeDetailList(params: {
  pageNum: number
  pageSize: number
}): Res<any> {
  return service.get('/h5/gold/bean/getExchangeDetailList', { params })
}

/**
 * 获取充值规则列表
 * @param params
 * @returns
 */
export function getRechargeRuleList(params: { platform: number }): Res<any> {
  return service.get('/recharge/getRechargeRuleList', { params })
}

/**
 * 获取充值规则列表
 * @param params
 * @returns
 */
export function getBindInfo(params: { Authorization: string }): Res<any> {
  return service.get('/h5/user/getBindInfo', { params })
}
/**
 * 获取钻石收支记录列表
 * @returns
 */
export function getDiamondRevenueExpensesList(): Res<any> {
  return service.get('/recharge/getDiamondRevenueExpensesList')
}

/**
 * 创建钻石充值订单
 * @param data
 * @returns
 */
export function createOrder(data: {
  payType: number
  rechargeConfigId: number
}): Res<any> {
  return service.post('/recharge/createOrder', data)
}

/**
 * 获取封禁用户列表
 * @returns
 */
export function getForbiddenUserList(): Res<any> {
  return service.post('/h5/user/getForbiddenUserList')
}

/**
 * 获取兜底提示配置
 * @returns
 */
export function getConfigToast(): Res<any> {
  return service.get('/h5/defaultHint/getHint')
}

/**
 * 获取兜底提示配置
 * @returns
 */
export function getKf(): Res<any> {
  return service.get('/h5/onlineCustomerService/query')
}
/**
 * 邀请周榜
 * @returns
 */
export function apiGetinviteWeekRanks(): Res<any> {
  return service.get('/h5/userInvite/weekList')
}
/**
 * 我的邀请
 * @returns
 */
export function apiGetinviteMyRanks(type: number): Res<any> {
  return service.get('/h5/userInvite/mine', {
    params: {
      type,
      pageNum: 1,
      pageSize: 9999
    }
  })
}
/**
 * 获取验证码
 * @returns
 */
export function apiGetVerificationCode(mobile: string): Res<any> {
  return service.get('/h5/sendMobileVerificationCode', {
    params: {
      mobile
    }
  })
}
/**
 * 邀请登录
 * @returns
 */
export function apiInViteLogin({
  code,
  mobile,
  invitationCode
}: {
  code: string
  mobile: string
  invitationCode: string
}): Res<any> {
  return service.post('/h5/invite/login', {
    code,
    mobile,
    invitationCode
  })
}
/**
 * 获取验证码
 * @returns
 */
export function apiGetTasks(): Res<any> {
  return service.get('/h5/messageTask/getTask')
}
